/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const DELETE_ACTION_SHIFT = gql`
  mutation DeleteActionShift($input: DeleteObjectInput!) {
    deleteActionShift(data: $input) {
      id
    }
  }
`
